import React from 'react';
import { Box, Modal, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

/**
 * Reusable Fullscreen Chart Modal Component
 * 
 * @param {boolean} open - Whether the modal is open
 * @param {function} onClose - Function to call when closing the modal
 * @param {string} title - Title to display in the modal header
 * @param {React.ReactNode} children - The chart content to display
 */
const FullscreenChartModal = ({ open, onClose, title, children }) => {
    return (
        <Modal
            open={open}
            onClose={onClose}
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <Box
                sx={{
                    width: { xs: '95vw', sm: '90vw', md: '85vw' },
                    height: { xs: '90vh', sm: '85vh', md: '80vh' },
                    bgcolor: '#ffffff',
                    borderRadius: '16px',
                    boxShadow: '0px 20px 60px rgba(0, 0, 0, 0.15)',
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    outline: 'none',
                }}
            >
                {/* Modal Header */}
                <Box
                    sx={{
                        padding: { xs: '16px 20px', md: '20px 24px' },
                        borderBottom: '1px solid #e6e6e6',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        bgcolor: '#fafafa',
                    }}
                >
                    <Typography
                        sx={{
                            fontSize: { xs: '18px', md: '22px' },
                            fontWeight: 600,
                            fontFamily: '"Inter", sans-serif',
                            color: '#333333',
                        }}
                    >
                        {title}
                    </Typography>
                    <IconButton
                        onClick={onClose}
                        sx={{
                            padding: '8px',
                            border: '1px solid #e6e6e6',
                            borderRadius: '8px',
                            bgcolor: '#ffffff',
                            '&:hover': {
                                bgcolor: '#f5f5f5',
                            },
                        }}
                    >
                        <CloseIcon sx={{ fontSize: '24px', color: '#666666' }} />
                    </IconButton>
                </Box>
                {/* Modal Content */}
                <Box
                    sx={{
                        flex: 1,
                        padding: { xs: '20px', md: '32px' },
                        minHeight: 0,
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    <Box
                        sx={{
                            flex: 1,
                            border: '1px solid #e0e0e0',
                            borderRadius: '20px',
                            padding: { xs: '16px', md: '24px' },
                            display: 'flex',
                            flexDirection: 'column',
                            bgcolor: '#ffffff',
                            minHeight: 0,
                        }}
                    >
                        {children}
                    </Box>
                </Box>
            </Box>
        </Modal>
    );
};

export default FullscreenChartModal;
